import React from "react";
import ProductCard from "./ProductCard";
import ScrollReveal from "./ScrollReveal";
import SectionHeader from "./SectionHeader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const FeaturedCarousel = ({ products, title = "SẢN PHẨM NỔI BẬT" }) => {
  if (!products || products.length === 0) return null;

  return (
    <div className="w-full pt-4 overflow-hidden">
      <SectionHeader
        title={title}
        subtitle="Lựa chọn hàng đầu cho bạn"
        accentColor="green"
      />

      <ScrollReveal variants="fade-in" delay={0.2} threshold={0.1}>
        <div className="featured-swiper-container pb-12 px-2">
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={16}
            slidesPerView={2}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
            }}
            className="w-full"
          >
            {products.map((p) => (
              <SwiperSlide key={p._id || p.name} className="py-2">
                <ProductCard product={p} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </ScrollReveal>

      <style>{`
        .featured-swiper-container .swiper-pagination-bullet {
          background: #10b981 !important;
          opacity: 0.3;
        }
        .featured-swiper-container .swiper-pagination-bullet-active {
          opacity: 1;
          width: 20px;
          border-radius: 5px;
        }
        /* Ensure SwiperSlide doesn't restrict ProductCard height */
        .featured-swiper-container .swiper-slide {
          height: auto !important;
          display: flex;
          flex-direction: column;
        }
      `}</style>
    </div>
  );
};

export default FeaturedCarousel;
